/// <amd-module name="Test/Analytics/Widgets/DetailsWidget/Constants" />
export const DetailsWidgetColumnNames = {
    itemName: "containerName",
    pointCount: "pointCount",
    runPercentage: "runPercentage",
    passedPercentage: "passedPercentage",
    notRunCount: "notRunCount",
    failedPercentage: "failedPercentage"
};

export const DetailsWidgetOdataPropertyNames = {
    runPercentage: "RunPercentage",
    notRunPercentage: "NotRunPercentage",
    passedPercentage: "PassedPercentage",
    failedPercentage: "FailedPercentage",
    runCount: "RunCount",
    notRunCount: "NotRunCount",
    testPlanTitle: "TestSuite/TestPlanTitle",
    testSuiteTitle: "TestSuite/TitleLevel",
    testSuiteId: "TestSuite/IdLevel",
    testPlanId: "TestSuite/TestPlanId",
    passedCount: "PassedCount",
    failedCount: "FailedCount",
    totalCount: "TotalCount"
};